export const IDS_ROLES = Object.freeze({
    ADMIN: 1,
    OPERADOR: 2,
    CONSULTA: 3
});